import { REQUEST_TYPE } from 'network/net'

export default function( settings )
{
    settings.slot.background = 'res/games/game_56/screen.png';
    settings.slot.underScreen = 'res/games/game_56/under_screen.png';
    settings.slot.underScreenPos = {x: 62, y: 126};
    settings.slot.symbol_animation_filename_pattern = 'res/games/game_56/balls/%d/%d';
    settings.slot.balls = 'res/games/game_56/balls/{symbol}/{symbol}_%03d.png';
    settings.slot.lines_pattern = 'res/games/game_55/lines/line_%02d.png';
    delete settings.slot.systemaTextColor
    settings.slot.terminalTextColor = 0xffe08b;
    delete settings.slot.left_billets_on_filename_pattern
    delete settings.slot.right_billets_on_filename_pattern
    settings.slot.underScreenPos = { x : 66, y : 123 }

    settings.table.background = 'res/games/game_56/table/background.png';
    settings.table.scatterPrice = {
        wins:[3,4,5],
        position:{x:1124, y:407}
    };
    delete settings.table.combinationNameFormat

    settings.table.frameYPos = [ 211, 270, 329, 388, 477, 536, 595 ];
    settings.table.priceTable = [
        {
            symbol:0,
            wins:[3,4,5],
            position:{x:937, y:215}
        },
        {
            symbol:1,
            wins:[3,4,5],
            position:{x:1124, y:215}
        },
        {
            symbol:2,
            wins:[3,4,5],
            position:{x:937, y:275}
        },
        {
            symbol:3,
            wins:[3,4,5],
            position:{x:1124, y:275}
        },
        {
            symbol:4,
            wins:[3,4,5],
            position:{x:937, y:333}
        },
        {
            symbol:5,
            wins:[3,4,5],
            position:{x:1124, y:333}
        },
        {
            symbol:6,
            wins:[2,3,4,5],
            position:{x:937, y:392}
        },
    ];
    
    settings.slot.lines_position = [
        [ 44, 402 ],
        [ 44, 209 ],
        [ 44, 597 ],
        [ 44, 145 ],
        [ 44, 205 ],
    ];
    settings.help.pages = 31;
    settings.help.pageNameFormat = "res/games/game_56/help/%02d.png";

    settings.texts.imgMain = 'res/games/game_56/game_text.png';
    settings.texts.posMain = { x : 1215, y : 124 }
    settings.texts.imgRisk = 'res/games/game_56/risk_text.png';
    settings.texts.posRisk = { x : 1215, y : 124 }

    settings.risk.background = 'res/games/game_56/risk/risk_screen.png';
    settings.risk.redButton.state.normal =
        settings.risk.redButton.state.over =
        settings.risk.redButton.state.pressed =
        settings.risk.redButton.state.disabled = 'res/games/game_56/risk/red_button.png';
    settings.risk.redButton.position = { x : 135, y : 407 };
    settings.risk.blackButton.state.normal =
        settings.risk.blackButton.state.over =
        settings.risk.blackButton.state.pressed =
        settings.risk.blackButton.state.disabled = 'res/games/game_56/risk/blue_button.png';
    settings.risk.blackButton.position = { x : 790, y : 407 };
    settings.risk.history.cardOffset = 94;
    settings.risk.currentWinLabel.font =
        settings.risk.nextWinLabel.font = 'game_56__digits_shag'
    settings.risk.currentWinLabel.position = { x : 120, y : 244 }
    settings.risk.nextWinLabel.position = { x : 1079, y : 244 }
    settings.risk.currentStepLabel.font =
        settings.risk.stepsLabel.font = 'game_56__shagi'
    settings.risk.redButton.position = { x : 123, y : 439 }
    settings.risk.blackButton.position = { x : 780, y : 439 }
    
    settings.risk.check = 'res/games/game_56/risk/risk_check.png'
    settings.risk.table_background = 'res/games/game_56/risk/risk_table.png'
    settings.risk.light_plates.name = 'res/games/game_56/risk/risk_table_light_part.png'
    
    settings.risk.blink_sound = 'res/games/game_56/bump'

    settings.ui.buttons.spin.frames.normal =          'res/games/game_56/ui/rezultat_on.png'
    settings.ui.buttons.spin.frames.disabled =        'res/games/game_56/ui/rezultat_off.png'
    settings.ui.buttons.collect.frames.normal =       'res/games/game_56/ui/rezultat_on.png'
    settings.ui.buttons.collect.frames.disabled =     'res/games/game_56/ui/rezultat_off.png'
    settings.ui.buttons.finish.frames.normal =        'res/games/game_56/ui/exit_pari_off.png';
    settings.ui.buttons.finish.frames.disabled =      'res/games/game_56/ui/exit_pari_off.png';
    settings.ui.buttons.end_pari.frames.normal =      'res/games/game_56/ui/exit_pari_off.png';
    settings.ui.buttons.end_pari.frames.disabled =    'res/games/game_56/ui/exit_pari_off.png';
    settings.ui.buttons.gamble.frames.normal =        'res/games/game_56/ui/auto_on.png';
    settings.ui.buttons.gamble.frames.disabled =      'res/games/game_56/ui/auto_off.png';
    settings.ui.buttons.risk_red.frames.normal =      'res/games/game_56/ui/red_on.png';
    settings.ui.buttons.risk_red.frames.disabled =    'res/games/game_56/ui/red_off.png';
    settings.ui.buttons.risk_black.frames.normal =    'res/games/game_56/ui/black_on.png';
    settings.ui.buttons.risk_black.frames.disabled =  'res/games/game_56/ui/black_off.png';

    settings.ui.buttons.autoplay.frames.normal =      'res/games/game_56/ui/auto_on.png';
    settings.ui.buttons.autoplay.frames.disabled =    'res/games/game_56/ui/auto_off.png';
    settings.ui.buttons.autoplayoff.frames.normal =   'res/games/game_56/ui/auto_off.png';
    settings.ui.buttons.autoplayoff.frames.disabled = 'res/games/game_56/ui/auto_on.png';
    settings.ui.buttons.menu.frames.normal =          'res/games/game_56/ui/menu_on.png';
    settings.ui.buttons.menu.frames.disabled =        'res/games/game_56/ui/menu_off.png';
    settings.ui.buttons.linebet.frames.normal =       'res/games/game_56/ui/size_step_on.png';
    settings.ui.buttons.linebet.frames.disabled =     'res/games/game_56/ui/size_step_off.png';
    settings.ui.buttons.visual_mode.frames.normal =   'res/games/game_56/ui/visual_mode_on.png';
    settings.ui.buttons.visual_mode.frames.disabled = 'res/games/game_56/ui/visual_mode_off.png';
    settings.ui.buttons.info.frames.normal =          'res/games/game_56/ui/info_on.png';
    settings.ui.buttons.info.frames.disabled =        'res/games/game_56/ui/info_off.png';
    
    settings.ui.buttons.spin.position =
        settings.ui.buttons.collect.position =     { x : 1453, y : 766 }
    settings.ui.buttons.autoplay.position =
        settings.ui.buttons.autoplayoff.position = { x : 1325, y : 766 }
    settings.ui.buttons.info.position =            { x : 1057, y : 9 }
    settings.ui.buttons.visual_mode.position =     { x : 2, y : 705 }
    settings.ui.buttons.finish.position =
        settings.ui.buttons.end_pari.position =    { x : 15, y : 8 }
    settings.ui.buttons.sound_on.position =
        settings.ui.buttons.sound_off.position =   { x : 1117, y : 67 }
    settings.ui.buttons.menu.position =            { x : 1195, y : 764 }
    settings.ui.buttons.linebet.position =         { x : 1195, y : 828 }
    
    
    settings.smallTicket.balls_screen = 'res/games/game_56/small_ticket/balls_screen.png'
    delete settings.smallTicket.lines_choice
    settings.smallTicket.risk_template = 'res/games/game_56/small_ticket/risk_screen%02d.png'
    
    settings.cheque.event = '«Событие М51»'


    return {
        //settings можно смело модифицировать - он копируется для каждой игры из шаблона:
        settings,

        //name для удобства чтения логов на сервере:
        name : 'game_56',
        //идентификатор математики на сервере:
        id : 584,

        reactive,

        graphics : [

            //small ticket:
            'res/games/game_56/small_ticket/balls_screen.png',
            'res/games/game_56/small_ticket/risk_screen00.png',
            'res/games/game_56/small_ticket/risk_screen01.png',

            //help:
            'res/games/game_56/help/00.png',
            'res/games/game_56/help/01.png',
            'res/games/game_56/help/02.png',
            'res/games/game_56/help/03.png',
            'res/games/game_56/help/04.png',
            'res/games/game_56/help/05.png',
            'res/games/game_56/help/06.png',
            'res/games/game_56/help/07.png',
            'res/games/game_56/help/08.png',
            'res/games/game_56/help/09.png',
            'res/games/game_56/help/10.png',
            'res/games/game_56/help/11.png',
            'res/games/game_56/help/12.png',
            'res/games/game_56/help/13.png',
            'res/games/game_56/help/14.png',
            'res/games/game_56/help/15.png',
            'res/games/game_56/help/16.png',
            'res/games/game_56/help/17.png',
            'res/games/game_56/help/18.png',
            'res/games/game_56/help/19.png',
            'res/games/game_56/help/20.png',
            'res/games/game_56/help/21.png',
            'res/games/game_56/help/22.png',
            'res/games/game_56/help/23.png',
            'res/games/game_56/help/24.png',
            'res/games/game_56/help/25.png',
            'res/games/game_56/help/26.png',
            'res/games/game_56/help/27.png',
            'res/games/game_56/help/28.png',
            'res/games/game_56/help/29.png',
            'res/games/game_56/help/30.png',

            //risk:
            'res/games/game_56/risk/blue_button.png',
            'res/games/game_56/risk/red_button.png',
            'res/games/game_56/risk/risk_screen.png',
            'res/games/game_56/risk/game_56__shagi.xml',
            'res/games/game_56/risk/game_56__digits_shag.xml',
            'res/games/game_56/risk/risk_check.png',
            'res/games/game_56/risk/risk_table.png',
            'res/games/game_56/risk/risk_table_light_part.png',

            //table:
            'res/games/game_56/table/background.png',

            //ui:
            'res/games/ui/yello_dig.xml',
            'res/games/game_56/ui/auto_off.png',
            'res/games/game_56/ui/auto_on.png',
            'res/games/game_56/ui/menu_on.png',
            'res/games/game_56/ui/menu_off.png',
            'res/games/game_56/ui/size_step_on.png',
            'res/games/game_56/ui/size_step_off.png',
            'res/games/game_56/ui/black_off.png',
            'res/games/game_56/ui/black_on.png',
            'res/games/game_56/ui/rezultat_on.png',
            'res/games/game_56/ui/rezultat_off.png',
            'res/games/game_56/ui/exit_pari_off.png',
            'res/games/game_56/ui/exit_pari_on.png',
            'res/games/game_56/ui/red_off.png',
            'res/games/game_56/ui/red_on.png',
            'res/games/game_56/ui/visual_mode_off.png',
            'res/games/game_56/ui/visual_mode_on.png',
            'res/games/game_56/ui/info_off.png',
            'res/games/game_56/ui/info_on.png',

            'res/games/game_56/screen.png',
            'res/games/game_56/under_screen.png',
            'res/games/game_56/game_text.png',
            'res/games/game_56/risk_text.png',

            'res/games/game_55/lines/line_00.png',
            'res/games/game_55/lines/line_01.png',
            'res/games/game_55/lines/line_02.png',
            'res/games/game_55/lines/line_03.png',
            'res/games/game_55/lines/line_04.png',

            'res/games/game_56/balls/0/0_000.png',
            'res/games/game_56/balls/0/0_001.png',
            'res/games/game_56/balls/0/0_002.png',
            'res/games/game_56/balls/0/0_003.png',
            'res/games/game_56/balls/0/0_004.png',
            'res/games/game_56/balls/0/0_005.png',
            'res/games/game_56/balls/0/0_006.png',
            'res/games/game_56/balls/0/0_007.png',
            'res/games/game_56/balls/0/0_008.png',
            'res/games/game_56/balls/1/1_000.png',
            'res/games/game_56/balls/1/1_001.png',
            'res/games/game_56/balls/1/1_002.png',
            'res/games/game_56/balls/1/1_003.png',
            'res/games/game_56/balls/1/1_004.png',
            'res/games/game_56/balls/1/1_005.png',
            'res/games/game_56/balls/1/1_006.png',
            'res/games/game_56/balls/1/1_007.png',
            'res/games/game_56/balls/1/1_008.png',
            'res/games/game_56/balls/2/2_000.png',
            'res/games/game_56/balls/2/2_001.png',
            'res/games/game_56/balls/2/2_002.png',
            'res/games/game_56/balls/2/2_003.png',
            'res/games/game_56/balls/2/2_004.png',
            'res/games/game_56/balls/2/2_005.png',
            'res/games/game_56/balls/2/2_006.png',
            'res/games/game_56/balls/2/2_007.png',
            'res/games/game_56/balls/2/2_008.png',
            'res/games/game_56/balls/3/3_000.png',
            'res/games/game_56/balls/3/3_001.png',
            'res/games/game_56/balls/3/3_002.png',
            'res/games/game_56/balls/3/3_003.png',
            'res/games/game_56/balls/3/3_004.png',
            'res/games/game_56/balls/3/3_005.png',
            'res/games/game_56/balls/3/3_006.png',
            'res/games/game_56/balls/3/3_007.png',
            'res/games/game_56/balls/3/3_008.png',
            'res/games/game_56/balls/4/4_000.png',
            'res/games/game_56/balls/4/4_001.png',
            'res/games/game_56/balls/4/4_002.png',
            'res/games/game_56/balls/4/4_003.png',
            'res/games/game_56/balls/4/4_004.png',
            'res/games/game_56/balls/4/4_005.png',
            'res/games/game_56/balls/4/4_006.png',
            'res/games/game_56/balls/4/4_007.png',
            'res/games/game_56/balls/4/4_008.png',
            'res/games/game_56/balls/5/5_000.png',
            'res/games/game_56/balls/5/5_001.png',
            'res/games/game_56/balls/5/5_002.png',
            'res/games/game_56/balls/5/5_003.png',
            'res/games/game_56/balls/5/5_004.png',
            'res/games/game_56/balls/5/5_005.png',
            'res/games/game_56/balls/5/5_006.png',
            'res/games/game_56/balls/5/5_007.png',
            'res/games/game_56/balls/5/5_008.png',
            'res/games/game_56/balls/6/6_000.png',
            'res/games/game_56/balls/6/6_001.png',
            'res/games/game_56/balls/6/6_002.png',
            'res/games/game_56/balls/6/6_003.png',
            'res/games/game_56/balls/6/6_004.png',
            'res/games/game_56/balls/6/6_005.png',
            'res/games/game_56/balls/6/6_006.png',
            'res/games/game_56/balls/6/6_007.png',
            'res/games/game_56/balls/6/6_008.png',
            'res/games/game_56/balls/7/7_000.png',
            'res/games/game_56/balls/7/7_001.png',
            'res/games/game_56/balls/7/7_002.png',
            'res/games/game_56/balls/7/7_003.png',
            'res/games/game_56/balls/7/7_004.png',
            'res/games/game_56/balls/7/7_005.png',
            'res/games/game_56/balls/7/7_006.png',
            'res/games/game_56/balls/7/7_007.png',
            'res/games/game_56/balls/7/7_008.png',

            
            //common:
            'res/games/preloader.png',
        ],
        sounds : [
            'res/games/game_56/bump',
            'res/games/game_56/magic_win',
            'res/games/game_56/spin_start',
        ],
    }
}

function reactive( { space, container } ) {
    space.s( 'request' )
        .filter( ({ type }) => type == REQUEST_TYPE.SPIN )
        .sound( { name : 'res/games/game_56/spin_start', loop : false } )
    
    space.s( 'presenter:regular_win' ).sound( { name : 'res/games/game_56/magic_win', loop : false })
}







// WEBPACK FOOTER //
// ./src/games/game_56.es6